<template>
  <div>

    <CompaniesRender :isLoading="isLoading" :company-data="companyData" />
    
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from "vue";
import requestHandler from "@/composables/requestHandler";
import CompaniesRender from "@/components/Company/CompaniesRender.vue";


// ############ Declaração de variáveis ############

let companyData = ref({}); 
let isLoading = ref(false)
 
// ############ Criação de Métodos/Funções ############

async function getCompanies() {
  isLoading.value = true

  const response = await requestHandler.executeRequest(`/api/company/index`,{},'get'); 
  
  if(response){
    companyData.value = response 
    isLoading.value = false 
  }
}


// function filtersTypes() {
//   filters.salary = 8000;
// }

//############ Propriedades Computadas ############

// ############ Observadores/watchs ############

// ############ Ciclos de Vida/Hooks ############

onBeforeMount(() =>{ 
  getCompanies()
})

</script>
